<template>
  <StepperTemplate :returnRoute="{ to: childCardRoute }">
    <template v-slot:title>
      <p class="h2-stepper-title mb-0 font-weight-bold text-blue-500 py-3 py-md-2">
        {{ title }}
      </p>
    </template>
    <template v-slot:body>
      <div class="stepper-body-card">
        <SupportOptionForFundraisingDonate v-if="isOpenFundraising" :shouldSetDefaults />
        <SupportOptionsForStartFundraising v-else :shouldSetDefaults />
      </div>
      <p class="h2-stepper-title mb-0 font-weight-bold text-blue-500 py-3 py-md-2">
        {{ $t('form.formOfPayment.title') }}
      </p>
      <div class="stepper-body-card d-none d-md-block">
        <PaymentMethod></PaymentMethod>
        <b-row align-h="end" class="mb-3">
          <b-col cols="6">
            <NextPageButton></NextPageButton>
          </b-col>
        </b-row>
      </div>
      <PaymentMethod class="d-block d-md-none"></PaymentMethod>
      <NextPageButton class="d-block d-md-none"></NextPageButton>
      <ScrollTopButton class="scroll-top-bottom-form"></ScrollTopButton>
    </template>
    <template v-slot:bottomSection>
      <FaqSection :content="content" extendable />
    </template>
  </StepperTemplate>
</template>

<script setup lang="ts">
import useTransactionDataStore from '@/stores/transactionData'
import { computed, reactive } from 'vue'
import { useI18n } from 'vue-i18n'
import type { RouteLocationNamedRaw } from 'vue-router'
import { useRoute } from 'vue-router'
// @ts-ignore
import { useStore } from 'vuex'

import NextPageButton from '@/components/formOfSupport/NextPageButton.vue'
import SupportOptionForFundraisingDonate from '@/components/formOfSupport/SupportOptionForFundraisingDonate.vue'
import SupportOptionsForStartFundraising from '@/components/formOfSupport/SupportOptionsForStartFundraising.vue'
import FaqSection from '@/components/widgets/FaqSection.vue'
import PaymentMethod from '@/components/widgets/paymentMethod/PaymentMethod.vue'
import ScrollTopButton from '@/components/widgets/ScrollTopButton.vue'
import StepperTemplate from '@/components/widgets/StepperTemplate.vue'

import { useRouterHistory } from '@/composables'

import type { AccordionItem } from 'node_modules/@wiosna-dev/wiosna-ui/dist/types/src/types/Accordion'

const { tm } = useI18n()
const content = computed<AccordionItem[]>(() => tm('faq.formOfSupportContent'))

const route = useRoute()

const childCardRoute = reactive<RouteLocationNamedRaw>({
  name: 'ChildPage',
  params: {
    childEditionId: route.params?.childEditionId
  }
})

const vuexStore = useStore()
const isOpenFundraising = computed<boolean>(
  () => vuexStore.getters['child/getChild']?.open_fundraising === true
)

const transactionDataStore = useTransactionDataStore()
const { initUseForm } = transactionDataStore
initUseForm()
const { from } = useRouterHistory()

// true if user hasn't come from FormOfDonorData page, otherwise false
const shouldSetDefaults: boolean = from.value?.name !== 'FormOfDonorData'

const { t } = useI18n()

const title = computed(() =>
  isOpenFundraising.value ? t('donorForm.foundraisingHeadline') : t('form.typeOfSupport.title')
)
</script>
